/* EarthBased vendor pincode checker + purchase gate - 10 Aug 2026 (v5)
   Replaces the Zippy Zipcode Validator app.

   HOW IT WORKS
   Only vendors WITH delivery restrictions are listed in the shop metafield
   custom.vendor_pincodes. If a product's vendor is not listed, this script does
   NOTHING AT ALL - no notice, no widget, no gating, buttons untouched, and the
   window.EB_PINCODE_LOCKED flag is never set.

   For a restricted vendor:
     - an always-visible notice explains the limited delivery area
     - Add To Cart and BUY NOW LOOK COMPLETELY NORMAL but are not usable;
       clicking either one smooth-scrolls to the pincode box and focuses it
     - once a serviceable pincode is entered, the block is removed entirely
     - the confirmed pincode is remembered (localStorage) and re-validated
       against each product's vendor, so customers are not asked repeatedly

   window.EB_PINCODE_LOCKED - DO NOT REMOVE
   Set true while the gate is blocking, false once unlocked. eb-cart-fix.js
   reads it. Without it, the cart safety net sees the blocked click as a failed
   add and adds the product anyway, defeating the gate and showing a false
   "Added to cart" toast. The scripts cannot coordinate through the DOM event,
   because eb-cart-fix.js registers its listener first and runs before this
   script's stopImmediatePropagation() can take effect.

   CARE POINTS - READ BEFORE EDITING
   - The buttons are deliberately NOT greyed out and NOT pointer-events:none.
     Blocking is done purely by a capture-phase click listener registered at
     parse time, which is why the script tag must NOT use defer or async -
     it has to be registered before Shiprocket's (fastrr) button script.
   - Never remove or replace Shiprocket's button element.
   - This is front-end gating: it stops honest customers, not determined ones.
     True enforcement has to happen in Shiprocket's checkout.

   EDIT COVERAGE AND WORDING
   Shopify admin > Settings > Custom data > Shop > Vendor pincode rules.
     "note"     - the always-visible notice on the product page
     "message"  - extra line shown when a pincode is NOT serviceable
     "pincodes" - exact serviceable pincodes
     "prefixes" - optional, matches any pincode starting with these digits
   Vendor names must match Shopify's Vendor field exactly (mind curly apostrophes). */
(function(){
  'use strict';

  var cfg = window.EB_PINCODE;
  if(!cfg || !cfg.vendor || !cfg.rules) return;
  var rule = cfg.rules[cfg.vendor];
  if(!rule) return; /* unrestricted vendor - do nothing */

  var GREEN = '#4a8e5a';
  var RED   = '#c0392b';
  var INK   = '#253d4e';
  var AMBER_BG = '#fff8e6';
  var AMBER_BD = '#f0d9a0';
  var STORE_KEY = 'eb_pincode';

  var outEl = null;
  var inputEl = null;

  function setLocked(v){
    window.EB_PINCODE_LOCKED = v;
  }
  setLocked(true); /* locked from the moment this script parses */

  function isLocked(){ return window.EB_PINCODE_LOCKED === true; }

  function serviceable(pin){
    var p = rule.prefixes || [];
    for(var i = 0; i < p.length; i++){ if(pin.indexOf(String(p[i])) === 0) return true; }
    var l = rule.pincodes || [];
    for(var j = 0; j < l.length; j++){ if(String(l[j]) === pin) return true; }
    return false;
  }

  function nudge(){
    var box = document.querySelector('.eb-pincode');
    if(!box) return;
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if(inputEl){ setTimeout(function(){ try { inputEl.focus(); } catch(e){} }, 350); }
    if(outEl){
      outEl.style.color = RED;
      outEl.textContent = 'Please check your pincode first.';
    }
    var panel = box.querySelector('.eb-pincode-panel');
    if(panel){
      panel.style.transition = 'box-shadow .25s ease';
      panel.style.boxShadow = '0 0 0 3px rgba(192,57,43,.18)';
      setTimeout(function(){ panel.style.boxShadow = ''; }, 1100);
    }
  }

  function blocker(e){
    if(!isLocked()) return;
    var t = e.target;
    if(!t || !t.closest) return;
    if(t.closest('.eb-pincode')) return;
    var hit = t.closest('.add-to-cart-button, button[name="add"], form.product-buy, [class*="fastrr"], [class*="buy-now"]');
    if(!hit) return;
    e.preventDefault();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    nudge();
  }
  document.addEventListener('click', blocker, true);

  function unlock(pin){
    setLocked(false);
    document.removeEventListener('click', blocker, true);
    try { localStorage.setItem(STORE_KEY, pin); } catch(err){}
  }

  function relock(){
    if(!isLocked()){
      setLocked(true);
      document.addEventListener('click', blocker, true);
    } else {
      setLocked(true);
    }
  }

  function build(){
    var host = document.querySelector('.product-custom-liquid');
    var form = document.querySelector('form.product-buy');
    if(!form || document.querySelector('.eb-pincode')) return;

    var box = document.createElement('div');
    box.className = 'eb-pincode';
    box.style.cssText = 'margin:14px 0;font-size:14px;color:' + INK;

    var notice = document.createElement('div');
    notice.className = 'eb-pincode-note';
    notice.style.cssText = 'display:flex;gap:8px;align-items:flex-start;padding:10px 12px;margin-bottom:10px;background:' + AMBER_BG + ';border:1px solid ' + AMBER_BD + ';border-radius:8px;font-size:13px;line-height:1.45';
    var marker = document.createElement('span');
    marker.textContent = '\uD83D\uDCCD';
    marker.style.cssText = 'flex:0 0 auto;line-height:1.3';
    var noteText = document.createElement('span');
    noteText.textContent = rule.note || rule.message || 'This product delivers only to selected pincodes.';
    notice.appendChild(marker); notice.appendChild(noteText);

    var panel = document.createElement('div');
    panel.className = 'eb-pincode-panel';
    panel.style.cssText = 'padding:12px 14px;border:1px solid #d8f1e5;border-radius:10px;background:#fff';

    var label = document.createElement('label');
    label.textContent = 'Enter your pincode to continue';
    label.style.cssText = 'display:block;font-weight:600;margin-bottom:8px;font-size:13px';

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px;align-items:center';

    var input = document.createElement('input');
    input.type = 'tel';
    input.inputMode = 'numeric';
    input.maxLength = 6;
    input.placeholder = '6-digit pincode';
    input.setAttribute('aria-label', 'Delivery pincode');
    input.style.cssText = 'flex:1 1 auto;min-width:0;padding:9px 12px;border:1px solid #d8f1e5;border-radius:6px;font-size:14px;color:' + INK;
    inputEl = input;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Check';
    btn.style.cssText = 'flex:0 0 auto;padding:9px 18px;border:0;border-radius:6px;background:' + GREEN + ';color:#fff;font-size:14px;cursor:pointer';

    var out = document.createElement('div');
    out.setAttribute('role', 'status');
    out.style.cssText = 'margin-top:8px;font-size:13px;line-height:1.45;min-height:18px';
    outEl = out;

    function check(silent){
      var v = (input.value || '').replace(/\D/g, '');
      if(!/^[1-9][0-9]{5}$/.test(v)){
        if(!silent){ out.style.color = RED; out.textContent = 'Please enter a valid 6-digit Indian pincode.'; }
        relock();
        return;
      }
      if(serviceable(v)){
        out.style.color = GREEN;
        out.textContent = '\u2713 Delivers to ' + v + '. You can place your order.';
        unlock(v);
      } else {
        out.style.color = RED;
        out.textContent = '\u2717 Sorry, we do not deliver this product to ' + v + ' yet.' + (rule.message ? ' ' + rule.message : '');
        relock();
      }
    }

    btn.addEventListener('click', function(){ check(false); });
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); check(false); } });

    row.appendChild(input); row.appendChild(btn);
    panel.appendChild(label); panel.appendChild(row); panel.appendChild(out);
    box.appendChild(notice); box.appendChild(panel);

    if(host && host.parentNode){ host.parentNode.insertBefore(box, host.nextSibling); }
    else { form.appendChild(box); }

    var saved = null;
    try { saved = localStorage.getItem(STORE_KEY); } catch(err){}
    if(saved){ input.value = saved; check(true); }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', build);
  } else { build(); }
})();
